import axios, { AxiosResponse } from 'axios'

import { env } from 'common/config/env'

export const postPasswordChangeRequest = async (email: string | undefined) => {
  const url = `https://${env.auth0Domain}/dbconnections/change_password`
  const payload = {
    email,
    connection: 'mongo',
    client_id: env.auth0ClientId,
  }

  if (payload.email === undefined) {
    throw new Error('Could not get your email, try logging in again.')
  }

  const result: AxiosResponse<{ data: string }> = await axios.post(
    url,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  return result.data
}
